module.exports = __webpack_public_path__ + "static/media/VIU.cd8f1ec9.svg";